import Box from '@sendsprint/ui-react/dist/components/Box';
import ErrorState from '@src/components/errorState';
import useMedia from '@src/hooks/utils/useMedia';
import React from 'react';

interface ErrorScreenProps {
  refetch?: () => void;
  errorText?: string;
}

const ErrorScreen = ({ refetch, errorText }: ErrorScreenProps) => {
  const { isMobile } = useMedia();
  return (
    <Box>
      <ErrorState
        iconSize={isMobile ? 'small' : 'normal'}
        errorText={errorText}
        showRetryBtn
        retryFunc={refetch}
      />
    </Box>
  );
};

export default ErrorScreen;
